import { RouteConfig } from 'vue-router';
import ResourceCreate from '@/components/Common/ResourceCreate.vue';
import { Permissions } from '@/types';

const MerchantList = () =>
  import(/* webpackChunkName: "merchant-routes" */ '@/components/Merchants/MerchantList.vue');
const MerchantCreate = () =>
  import(/* webpackChunkName: "merchant-routes" */ '@/components/Merchants/MerchantCreate.vue');
const MerchantEdit = () =>
  import(/* webpackChunkName: "merchant-routes" */ '@/components/Merchants/MerchantEdit.vue');
const MerchantView = () =>
  import(/* webpackChunkName: "merchant-routes" */ '@/components/Merchants/MerchantView.vue');

const routes: RouteConfig[] = [
  {
    path: 'merchants',
    name: 'merchants',
    components: {
      default: MerchantList,
      pageActions: ResourceCreate
    },
    props: {
      pageActions: {
        text: 'Add Merchant'
      }
    },
    meta: {
      pageTitle: 'Merchants',
      showDateRangePicker: true,
      permission: Permissions.QUERY_MERCHANTS
    }
  },
  {
    path: 'merchants/create',
    name: 'merchants-create',
    components: {
      default: MerchantCreate
    },
    meta: {
      pageTitle: 'Create Merchant',
      showBackButton: true,
      permission: Permissions.CREATE_MERCHANT
    }
  },
  {
    path: 'merchants/:id(\\d+)/edit',
    name: 'merchants-edit',
    components: {
      default: MerchantEdit
    },
    props: {
      default: (route: any) => ({
        merchantId: parseInt(route.params.id)
      })
    },
    meta: {
      pageTitle: 'Edit Merchant',
      showBackButton: true,
      permission: Permissions.UPDATE_MERCHANT
    }
  },
  {
    path: 'merchants/:id(\\d+)/view',
    name: 'merchants-view',
    components: {
      default: MerchantView,
      pageActions: ResourceCreate
    },
    props: {
      default: (route: any) => ({
        merchantId: parseInt(route.params.id)
      }),
      pageActions: (route: any) => ({
        text: 'Edit Merchant',
        route: {
          name: 'merchants-edit',
          merchantId: parseInt(route.params.id)
        }
      })
    },
    meta: {
      pageTitle: 'Merchant Info',
      showDateRangePicker: true,
      showBackButton: true,
      permission: Permissions.QUERY_MERCHANT
    }
  }
];

export default routes;
